import React, { Component } from 'react';
import { Row, Col, Container } from 'reactstrap';

export class TitleSubtitleBanner extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
        <Container className={'text-center py-5'} id={this.props.id}>
            <Row>
                <Col xl={10} sm={12} className={'mx-auto'}>
                    <h2>{this.props.title}</h2>
                    <p>{this.props.subtitle}</p>
                </Col>
            </Row>
            <Row>
                <Col xl={10} sm={12} className={'mx-auto'}>
                    <p>{this.props.description}</p>
                </Col>
            </Row>
        </Container>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/banners/TitleSubtitleBanner.js